import { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logoCentrao from '../assets/logo-centrao.png';
import logoCBranca from '../assets/logo-c-branca.png';

export default function Sidebar() {
  const { user, logout, temPermissao } = useAuth();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => { setMobileOpen(false); }, [location.pathname]);

  useEffect(() => {
    const fechar = () => setMobileOpen(false);
    window.addEventListener('orientationchange', fechar);
    window.addEventListener('resize', fechar);
    return () => {
      window.removeEventListener('orientationchange', fechar);
      window.removeEventListener('resize', fechar);
    };
  }, []);

  useEffect(() => {
    if (!mobileOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prev; };
  }, [mobileOpen]);

  return (
    <>
      <div className="mobile-header">
        <button onClick={() => setMobileOpen(!mobileOpen)} aria-label={mobileOpen ? 'Fechar menu' : 'Abrir menu'}>
          <i className={`bi ${mobileOpen ? 'bi-x-lg' : 'bi-list'}`}></i>
        </button>
        <img
          src={logoCentrao}
          alt="Centrão"
          style={{
            height: 28, width: 'auto', objectFit: 'contain',
            background: '#fff', borderRadius: 6, padding: '2px 6px',
          }}
        />
        <div className="sidebar-title ms-auto" style={{ fontSize: '0.78rem' }}>Portal Arquitetos</div>
      </div>

      <div className={`sidebar-overlay ${mobileOpen ? 'open' : ''}`} onClick={() => setMobileOpen(false)} />

      <nav className={`sidebar ${mobileOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          {/* Ícone "C" quadrado — visível no estado rail colapsado */}
          <img
            src={logoCBranca}
            alt="Centrão"
            className="sidebar-logo-icone"
            style={{
              height: 58, width: 'auto', objectFit: 'contain', flexShrink: 0,
            }}
          />
          {/* Logo horizontal completa — visível quando sidebar expandida (hover/drawer) */}
          <img
            src={logoCentrao}
            alt="Centrão Materiais de Construção"
            className="sidebar-logo-completa sidebar-label"
            style={{
              width: '100%',
              height: 'auto',
              maxHeight: 54,
              objectFit: 'contain',
              background: '#fff',
              borderRadius: 11,
              padding: '9px 13px',
              boxShadow: '0 4px 14px rgba(0,0,0,0.18)',
            }}
          />
        </div>

        <div className="sidebar-subtitulo sidebar-label">Portal do Arquiteto</div>

        <div className="sidebar-nav">
          <div className="sidebar-section sidebar-label">Geral</div>
          <NavLink to="/dashboard" title="Dashboard">
            <i className="bi bi-speedometer2"></i>
            <span className="nav-label sidebar-label">Dashboard</span>
          </NavLink>
          {(user?.tipo === 'arquiteto' || temPermissao('comissoes_listar')) && (
            <NavLink to="/comissoes" title="Comissões">
              <i className="bi bi-cash-coin"></i>
              <span className="nav-label sidebar-label">
                {user?.tipo === 'arquiteto' ? 'Minhas Comissões' : 'Comissões'}
              </span>
            </NavLink>
          )}

          {(user?.tipo !== 'arquiteto' || user?.catalogo_visivel) && (
            <NavLink to="/catalogo" title="Catálogo de Pisos">
              <i className="bi bi-grid-1x2"></i>
              <span className="nav-label sidebar-label">Catálogo</span>
            </NavLink>
          )}
          {(user?.tipo !== 'arquiteto' || user?.catalogo_visivel) && (
            <NavLink to="/especificacoes" title="Minhas especificações">
              <i className="bi bi-clipboard2-check"></i>
              <span className="nav-label sidebar-label">Especificações</span>
            </NavLink>
          )}

          {user?.tipo === 'arquiteto' && (
            <NavLink to="/saques" title="Solicitar Saque">
              <i className="bi bi-bank"></i>
              <span className="nav-label sidebar-label">Solicitar Saque</span>
            </NavLink>
          )}
          {/* Aprovação de saques migrou pro Portal Financeiro (mai/2026) —
              quem precisa aprovar entra em https://financeiro.centraomateriais.com */}

          {user?.tipo !== 'arquiteto' && (
            temPermissao('arquitetos_listar') || temPermissao('arquitetos_vincular') ||
            temPermissao('arquitetos_editar') || temPermissao('auditoria_saques') ||
            temPermissao('usuarios_listar') || temPermissao('perfis_gerenciar') ||
            temPermissao('catalogo_destaques') || temPermissao('saldos_arquitetos')
          ) && (<>
            <div className="sidebar-section sidebar-label">Administração</div>
            {(temPermissao('arquitetos_listar') || temPermissao('arquitetos_vincular') || temPermissao('arquitetos_editar')) && (
              <NavLink to="/arquitetos" title="Arquitetos">
                <i className="bi bi-person-badge"></i>
                <span className="nav-label sidebar-label">Arquitetos</span>
              </NavLink>
            )}
            {temPermissao('saldos_arquitetos') && (
              <NavLink to="/saldos-arquitetos" title="Saldos de Arquitetos">
                <i className="bi bi-wallet2"></i>
                <span className="nav-label sidebar-label">Saldos de Arquitetos</span>
              </NavLink>
            )}
            {temPermissao('catalogo_destaques') && (
              <NavLink to="/catalogo-destaques" title="Destaques do Catálogo">
                <i className="bi bi-star"></i>
                <span className="nav-label sidebar-label">Destaques</span>
              </NavLink>
            )}
            {temPermissao('catalogo_destaques') && (
              <NavLink to="/catalogo-gestao" title="Gestão do catálogo">
                <i className="bi bi-diagram-3"></i>
                <span className="nav-label sidebar-label">Gestão do catálogo</span>
              </NavLink>
            )}
            {temPermissao('auditoria_saques') && (
              <NavLink to="/auditoria-saques" title="Auditoria de Saques">
                <i className="bi bi-clipboard-data"></i>
                <span className="nav-label sidebar-label">Auditoria de Saques</span>
              </NavLink>
            )}
            {temPermissao('usuarios_listar') && (
              <NavLink to="/usuarios" title="Usuários">
                <i className="bi bi-people"></i>
                <span className="nav-label sidebar-label">Usuários</span>
              </NavLink>
            )}
            {temPermissao('perfis_gerenciar') && (
              <NavLink to="/perfis" title="Perfis">
                <i className="bi bi-shield-check"></i>
                <span className="nav-label sidebar-label">Perfis</span>
              </NavLink>
            )}
          </>)}
        </div>

        <div className="sidebar-bottom">
          <div className="sidebar-user-info sidebar-label">
            <div className="sidebar-avatar">{(user?.nome || '?').trim().charAt(0).toUpperCase()}</div>
            <div className="sidebar-user-text">
              <div className="sidebar-user-nome">{user?.nome}</div>
              <div className="sidebar-user-grupo">{user?.perfil_nome}</div>
            </div>
          </div>
          <div className="sidebar-acoes-row">
            <NavLink to="/meu-perfil" className="sidebar-acao-btn" title="Meu Perfil">
              <i className="bi bi-gear"></i>
              <span className="sidebar-label">Perfil</span>
            </NavLink>
            <button className="sidebar-acao-btn" onClick={logout} title="Sair">
              <i className="bi bi-box-arrow-left"></i>
              <span className="sidebar-label">Sair</span>
            </button>
          </div>
        </div>

        <div className="sidebar-footer sidebar-label">
          Elaborado por: TI Centrão
        </div>
      </nav>
    </>
  );
}
